import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { FormField, CheckboxWithInputOptions } from '../../types/form';

interface CheckboxWithInputFieldEditorProps {
  editedField: FormField;
  onFieldChange: (updates: Partial<FormField>) => void;
}

export const CheckboxWithInputFieldEditor: React.FC<CheckboxWithInputFieldEditorProps> = ({
  editedField,
  onFieldChange,
}) => {
  const options = (editedField.options || {}) as CheckboxWithInputOptions;
  
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor={`inputType-${editedField.id}`}>Input Type</Label>
        <Select
          value={options.inputType || 'text'}
          onValueChange={(value) => onFieldChange({ 
            options: { 
              ...editedField.options,
              inputType: value
            }
          })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select input type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="text">Text</SelectItem>
            <SelectItem value="number">Number</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor={`inputPlaceholder-${editedField.id}`}>Input Placeholder</Label>
        <Input
          id={`inputPlaceholder-${editedField.id}`}
          value={options.inputPlaceholder || ''}
          onChange={(e) => onFieldChange({ 
            options: { 
              ...editedField.options,
              inputPlaceholder: e.target.value
            }
          })}
          placeholder="Enter placeholder for the input field"
        />
      </div>
    </div>
  );
};
